<template>
  <v-responsive
    v-if="order.design_id == nullCoverDesignId"
    class="d-flex align-center overflow-visible"
    :aspect-ratio="$vuetify.breakpoint.xsOnly ? 16 / 9 : 5 / 7"
    :width="w"
  >
    <v-card v-if="groupVideoBlob" tile>
      <v-img :aspect-ratio="16 / 9" :src="groupVideoBlob.group_video.poster || '/poster-placeholder.png'" />
    </v-card>
    <v-card v-else-if="giftcard" class="gc-border" dark>
      <v-img :aspect-ratio="300 / 190" :src="giftcard.product_img" />
    </v-card>
  </v-responsive>
  <v-card v-else class="overflow-visible" v-bind:style="{ width: w + 'px', height: (w / (5 / 7)) + 'px' }" tile>
    <v-lazy>
      <card-preview
        :mode="mode"
        :card="order"
        :is-card-owner="isCardOwner"
        :is-verified-recipient="isVerifiedRecipient"
        :width="w"
      />
    </v-lazy>
    <!-- <v-btn v-if="order.api" class="absolute" style="left: -4px; bottom: -4px; transform: scale(.75); transform-origin: bottom left;" label x-small color="primary">API</v-btn> -->
  </v-card>
</template>

<script>
import CardPreview from '@/components/CardPreview.vue';
import { nullCoverDesignId } from '@/mixins/public-design.js';
import { findGroupVideoBlob } from '@/utils/group-video.js';
import { mdiApi } from '@mdi/js';

export default {
  name: 'account-order-preview',

  components: {
    CardPreview
  },

  props: [ 'mode', 'order', 'isCardOwner', 'isVerifiedRecipient', 'width' ],

  computed: {
    giftcard() {
      for (const page of this.order.pages)
        for (const blob of page.blobs)
          if (blob.type == 'GIFTCARD')
            return blob.giftcard;
      return null;
    },

    groupVideoBlob() {
      return findGroupVideoBlob(this.order);
    },

    w() {
      return this.width || (this.$vuetify.breakpoint.xsOnly ? 112 : 84);
    }
  },

  created() {
    Object.assign(this, { nullCoverDesignId, mdiApi });
  }
}
</script>
